// extracted by mini-css-extract-plugin
export default {"info":"totalAmountSection_info__8zKlq"};